import { render, staticRenderFns } from "./PayPalCard.vue?vue&type=template&id=a6059844&scoped=true"
import script from "./PayPalCard.vue?vue&type=script&lang=js"
export * from "./PayPalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6059844",
  null
  
)

export default component.exports